import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import useFormValidation from 'hooks/useFormValidation';

import { meApi, auth } from 'api';
import paths from 'routes/paths';

const initialValues = {
  password: '',
};

const validationSchema = {
  password: {
    required: 'Password is required',
  },
};

const AccountDeactivateModal = ({ show, onHide }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    validateForm,
    resetForm,
    isValid,
  } = useFormValidation(initialValues, validationSchema);

  const handleClose = () => {
    resetForm();
    onHide();
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    try {
      await meApi.deactivateMe({ password: values.password });
      toast.success('Account deactivated successfully');

      auth.clearAuth();
      navigate(paths.login, { replace: true });
    } catch (err) {
      toast.error('Failed to deactivate account');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Deactivate Account</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>Please enter your password to confirm</Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={values.password}
              onChange={e => handleChange('password', e.target.value)}
              onBlur={() => handleBlur('password')}
              isInvalid={touched.password && errors.password}
              placeholder="Enter password"
            />
            <Form.Control.Feedback type="invalid">
              {errors.password}
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" variant="danger" disabled={!isValid || loading}>
            {loading ? 'Deactivating...' : 'Confirm'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AccountDeactivateModal;
